<template>
  <v-card>
    <v-toolbar color="white" elevation="4" flat prominent>
      <v-text-field
        append-icon="mdi-microphone"
        class="mx-4"
        flat
        hide-details
        label="Search"
        prepend-inner-icon="mdi-magnify"
        solo-inverted
      ></v-text-field>

      <v-spacer> </v-spacer>
      <v-btn style="width:20%;" class="mr-4" large outlined @click="this.openInventoryDialog">
        <v-icon class="mr-2"> mdi-note-plus-outline</v-icon>
        Add Inventory Item</v-btn
      >
      <v-btn style="width:21%;" large outlined @click="this.openDemandDialog">
        <v-icon class="mr-2"> mdi-note-plus-outline</v-icon>
        Add Items in Demand</v-btn
      >
      <div>
        <dialog-container>
          <div v-if="inventoryDialog" slot="content">
            <add-inventory-item-form />
          </div>

          <div v-if="demandDialog" slot="content">
            <add-high-demand-form />
          </div>
        </dialog-container>
      </div>
      <template v-slot:extension>
        <v-tabs v-model="tabs" centered>
          <v-tab class="primary--text">Donation Inventory Item</v-tab>
          <v-tab class="primary--text">High Demand Items</v-tab>
          <v-tab class="primary--text">Registration For Donation</v-tab>
        </v-tabs>
      </template>
    </v-toolbar>
    <v-divider> </v-divider>
    <!-- MAP of the Center -->

    <Map :point="this.currentMapLocation" />

    <v-tabs-items v-model="tabs">
      <!-- Donation Inventory Item  -->
      <v-tab-item>
        <v-container fluid v-for="(item, index) in inventory" :key="index">
          <donation-inventory-list
            :date="item.date"
            :description="item.description"
            :fullName="item.fullName"
            :location="item.location"
            :phoneNumber="item.phoneNumber"
            :userId="item.userId"
          />
        </v-container>
      </v-tab-item>

      <!-- High demand Items  -->
      <v-tab-item>
        <v-container fluid v-for="(item, index) in demand" :key="index">
          <high-demand-list
            :caption="item.caption"
            :demandRate="item.demandRate"
            :image="item.image"
            :name="item.name"
            :timestamp="item.timestamp"
          />
        </v-container>
      </v-tab-item>

      <!-- Registration For Donation  -->
      <v-tab-item>
        <v-container fluid>
          <donation-registeration-list />
        </v-container>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template> 

<script>
import moment from "moment";
import Map from "../shared/components/Map";
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";
import { eventBus } from "@/main.js";
import DonationInventoryList from "../components/DonationInventoryList";
import HighDemandList from "../components/HighDemandList";
import DonationRegisterationList from "../components/DonationRegisterationList";
import DialogContainer from "../shared/components/dialogContainer";
import AddInventoryItemForm from "../forms/AddInventoryItemForm";
import AddHighDemandForm from "../forms/AddHighDemandForm";
export default {
  name: "DonationsInventory",
  async created() {
    if (this.$route.params.id) {
      this.selectedDonationCenterId({
        payload: {
          centerId: this.$route.params.id,
        },
      });
      await this.selectedDonationCenterItems({
        payload: {
          centerId: this.$route.params.id,
        },
      });

      await this.fetchHighDemandItems({
        payload: {
          centerId: this.$route.params.id,
        },
      });

      // extract the specific location from the centers object
      // filter based on the center Id
      var location;
      this.donationCenters.find((element) => {
       
        if (element.id == this.$route.params.id) {
          location = element.content.location;
         
          // if the location is in Array format
          // extract it differently from the object
          if (location[0]) {
         
            this.currentDonationCenterLocation({
              payload: {
                lat: location[0].lat,
                long: location[0].long,
              },
            });
          } else {
            this.currentDonationCenterLocation({
              payload: {
                lat: location.x_,
                long: location.N_,
              },
            });
          }
        }
      });
    }
  },

  components: {
    Map,
    DonationInventoryList,
    HighDemandList,
    DonationRegisterationList,
    AddInventoryItemForm,
    DialogContainer,
    AddHighDemandForm,
  },
  computed: {
    ...mapFields("donation", [
      "donationCenterItems",
      "highDemands",
      "donationCenters",
      "donationCenterId",
      "currentMapLocation",
    ]),
  },
  data() {
    return {
      tab: null,
      tabs: null,
      demandDialog: false,
      inventoryDialog: false,
      inventory: [],
      demand: [],
    };
  },
  methods: {
    ...mapActions("donation", [
      "fetchHighDemandItems",
      "selectedDonationCenterItems",
      "selectedDonationCenterId",
      "currentDonationCenterLocation",
    ]),
    openDemandDialog() {
      this.demandDialog = true;
      this.inventoryDialog = false;
      eventBus.$emit("dialogToggle", true);
    },
    openInventoryDialog() {
      this.demandDialog = false;
      this.inventoryDialog = true;
      eventBus.$emit("dialogToggle", true);
    },
  },
  watch: {
    donationCenterItems: {
      immidate: true,
      handler(value) {
        if (value.length != 0) {
          value.map((item) => {
            // format date
            var iso, utc, date, time, image;
            // The new donation dates created on from Admin will always
            // have Number Timestamp thus separate old news creations from new ones
            if (!item.content.date.seconds) {
              iso = moment.utc(item.content.date * 1000).format();
              utc = moment(iso)
                .format("dddd, MMMM Do YYYY, h:mm:ss a")
                .split(",");
              date = utc[0] + utc[1].toString();
              time = utc[2].toString();
            } else {
              // Convert the TimeStamp date to appropriate Date and Time
              iso = moment.utc(item.content.date.seconds * 1000).format();
              utc = moment(iso)
                .format("dddd, MMMM Do YYYY, h:mm:ss a")
                .split(",");
              date = utc[0] + utc[1].toString();
              time = utc[2].toString();
            }
            this.inventory.push({
              date: date,
              description: item.content.description,
              fullName: item.content.fullName,
              location: {},
              phoneNumber: item.content.phoneNumber,
              userId: item.content.userId,
            });
          });
        }
      },
    },
    highDemands: {
      immidate: true,
      handler(value) {
        if (value.length != 0) {
         

          value.map((item) => {
            // format date
            var iso, utc, date, time, image;
            // The new donation dates created on from Admin will always
            // have Number Timestamp thus separate old news creations from new ones
            if (!item.content.timestamp.seconds) {
              iso = moment.utc(item.content.timestamp * 1000).format();
              utc = moment(iso)
                .format("dddd, MMMM Do YYYY, h:mm:ss a")
                .split(",");
              date = utc[0] + utc[1].toString();
              time = utc[2].toString();
            } else {
              // Convert the TimeStamp date to appropriate Date and Time
              iso = moment.utc(item.content.timestamp.seconds * 1000).format();
              utc = moment(iso)
                .format("dddd, MMMM Do YYYY, h:mm:ss a")
                .split(",");
              date = utc[0] + utc[1].toString();
              time = utc[2].toString();
            }
            // reactivity
            this.demand.push({
              caption: item.content.caption,
              demandRate: item.content.demandRate,
              image: item.content.image,
              name: item.content.name,
              timestamp: date,
            });
          });
        }
      },
    },
  },
};
</script>



